import { vehicleFormInitialValues, getVehicleValidationSchema } from 'src/components/vehicles/vehicleFormModel';

const value = (raw) => (raw === null || raw === undefined ? '' : raw);

export const emptyVehicleForm = () => ({
  ...vehicleFormInitialValues,
  no_of_tanks: 1,
  tyre_management_enabled: false,
});

export const formFromVehicle = (details) => ({
  ...emptyVehicleForm(),
  registration_num: value(details.registration_num),
  asset_code: value(details.asset_code),
  model: value(details.model),
  type: value(details.type),
  category: value(details.category),
  consumer_vehicle: value(details.consumer_vehicle),
  site: value(details.site),
  group: value(details.group),
  department: value(details.department),
  contractor: details.contractor?.id || details.contractor_id || details.contractor || '',
  po_number: value(details.po_number),
  fuel_type: value(details.fuel_type),
  tank_capacity: value(details.tank_capacity),
  no_of_tanks: value(details.no_of_tanks),
  tank: value(details.tank),
  standard_mileage: Number(details.standard_mileage) > 0 ? details.standard_mileage : '',
  max_diff_allowed: value(details.max_diff_allowed),
  monthly_fixed_engine_hours: value(details.monthly_fixed_engine_hours),
  odometer_reading: value(details.odometer_reading),
  service_interval: value(details.service_interval),
  telemetics_enabled: Boolean(details.telemetics_enabled),
  telemetics_category: value(details.telemetics_category),
  fleet_service_provider: value(details.fleet_service_provider),
  show_omnicomm_log_ignition: details.show_omnicomm_log_ignition ?? true,
  show_omnicomm_log_engine: details.show_omnicomm_log_engine ?? true,
  show_omnicomm_log_secondary_engine: details.show_omnicomm_log_secondary_engine ?? false,
  omnicomm_secondary_engine_threshold: details.omnicomm_secondary_engine_threshold ?? 8,
  tyre_management_enabled: Boolean(details.tyre_management_enabled),
});

export const normalizeVehiclePayload = (
  form,
  {
    includeTyreManagement = true,
  } = {}
) => {
  const payload = { ...form };
  ['group', 'department', 'contractor', 'tank', 'model'].forEach((key) => {
    payload[key] = payload[key] || null;
  });
  ['tank_capacity', 'no_of_tanks', 'standard_mileage', 'max_diff_allowed', 'odometer_reading', 'service_interval', 'omnicomm_secondary_engine_threshold'].forEach((key) => {
    if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
      if (key === 'standard_mileage') delete payload[key];
      else payload[key] = key === 'no_of_tanks' ? 1 : 0;
    } else payload[key] = Number(payload[key]);
  });
  payload.monthly_fixed_engine_hours = payload.monthly_fixed_engine_hours === ''
    ? null
    : Number(payload.monthly_fixed_engine_hours);
  const standardMileageValue = Number(payload.standard_mileage);
  if (!payload.standard_mileage || Number.isNaN(standardMileageValue) || standardMileageValue <= 0) {
    delete payload.standard_mileage;
  }
  if (!payload.telemetics_enabled) {
    payload.telemetics_category = '';
    payload.fleet_service_provider = '';
  }
  if (includeTyreManagement) payload.tyre_management_enabled = Boolean(payload.tyre_management_enabled);
  else delete payload.tyre_management_enabled;
  delete payload.tyre_management_enabled_at;
  return payload;
};

export const parseFieldErrors = (fields) => {
  if (!fields || typeof fields === 'string') return {};
  return Object.fromEntries(
    Object.entries(fields).map(([key, messages]) => [key, Array.isArray(messages) ? messages.join(' ') : String(messages)])
  );
};

export const validateVehicleForm = async (form, { assetCodeMappingEnabled = false, isEdit = false } = {}) => {
  try {
    await getVehicleValidationSchema({ assetCodeMappingEnabled, isEdit }).validate(form, { abortEarly: false });
    return {};
  } catch (error) {
    const next = {};
    (error.inner || []).forEach((item) => {
      if (item.path && !next[item.path]) next[item.path] = item.message;
    });
    if (!Object.keys(next).length && error.message) next.form = error.message;
    return next;
  }
};
